import { EyeOff } from 'lucide-react';
import { cn } from '@/shared/lib/cn';

/**
 * Kanalregeln, die ein Apartment hier schließen und zugleich eines, das du nicht siehst. Der Server
 * zählt sie nur (Name und Ziele verrieten fremde Apartments); ohne diesen Hinweis hieße es „keine
 * Regel“, wo eine wirkt.
 */
export function CloseoutsOutsideViewNote({
  count,
  apartment = false,
  className,
}: {
  count: number | undefined;
  /** In der Monatsansicht: die Regel schließt dieses Apartment, nicht nur „Apartments hier“. */
  apartment?: boolean;
  className?: string;
}) {
  if (typeof count !== 'number' || !(count > 0)) return null;
  const one = count === 1;
  return (
    <p
      role="note"
      className={cn(
        'bg-card-alt text-ink-soft rounded-control flex items-start gap-2 px-3 py-2 text-[13px]',
        className,
      )}
    >
      <EyeOff size={14} className="mt-0.5 shrink-0" aria-hidden />
      <span>
        {one ? 'Eine weitere Kanalregel schließt' : `${count} weitere Kanalregeln schließen`}{' '}
        {apartment ? 'dieses Apartment' : 'Apartments hier'} und zugleich welche, die du nicht
        siehst. {one ? 'Sie steht' : 'Sie stehen'} deshalb nicht in dieser Ansicht; ändern kann sie,
        wer alle betroffenen Apartments sieht.
      </span>
    </p>
  );
}
